import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API } from "@/lib/api";
import { CalendarBlank, ArrowUpRight } from "@phosphor-icons/react";

const BASE = API.replace(/\/api$/, "");

export default function UpcomingDrops() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/upcoming").then(({ data }) => setItems(data.releases)).catch(() => {}); }, []);
  if (items.length === 0) return null;

  return (
    <section className="border-b border-zinc-800 bg-zinc-950" data-testid="upcoming-drops">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8 flex flex-col lg:flex-row lg:items-center gap-6">
        <div className="flex items-center gap-3 shrink-0 lg:w-56">
          <CalendarBlank size={22} weight="duotone" className="text-red-600" />
          <div>
            <div className="font-display text-xl uppercase tracking-tight leading-none">Upcoming<br />Drops<span className="text-red-600">.</span></div>
          </div>
        </div>
        <div className="flex gap-px bg-zinc-800 border border-zinc-800 overflow-x-auto flex-1">
          {items.map(r => {
            const d = new Date(`${r.release_date}T00:00:00`);
            const days = Math.max(0, Math.round((d - new Date().setHours(0, 0, 0, 0)) / 86400000));
            return (
              <Link key={r.id} to={`/presave/${r.presave_slug}`} data-testid={`upcoming-${r.id}`} className="bg-black min-w-[220px] flex items-center gap-3 p-3 group hover:bg-zinc-900 transition-colors">
                <img src={`${BASE}${r.cover_url}`} alt={`${r.title} cover art`} loading="lazy" className="w-12 h-12 object-cover grayscale group-hover:grayscale-0 transition-all" />
                <div className="min-w-0 flex-1">
                  <div className="text-sm truncate">{r.title}</div>
                  <div className="text-[10px] text-zinc-500 truncate">{r.artist_name}</div>
                  <div className="text-[10px] tracking-widest uppercase mt-1 text-red-500">{days === 0 ? "Today" : `${d.toLocaleDateString("en-US", { month: "short", day: "numeric" })} · ${days}d`}</div>
                </div>
                <ArrowUpRight size={12} className="text-zinc-600 group-hover:text-white" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
